import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import '@adornis/entity-picker/client/x-entity-picker.js';
import '@adornis/entity-picker/client/x-multi-entity-picker.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import { Product } from '@chancenwerk/_cms/products/entities/Product.js';
import '@chancenwerk/client/components/semantics/chancen-component-semantic-product-picker.js';
import { html } from 'lit';

@Entity()
export class ProductAspect extends AbstractAspect {
  static override _class = 'ProductAspect';

  constructor(doc: PartialEntityData<ProductAspect>) {
    const newDoc = doc;
    if (!newDoc.fieldName && !newDoc.customID) newDoc.fieldName = 'produkt._class';
    super(newDoc);
  }

  @Field(type => [String], { default: v => v ?? [] }) values: Maybe<string[]>;
  @Field(type => [String]) names: Maybe<string[]>;

  override getMongoFilter(): object | null {
    if (!this.values?.length || this.customID) return null;

    let field = this.fieldName ?? 'produkt._class';

    return {
      [field]: {
        $in: this.values,
      },
    };
  }
}

export const ProductMultiAspectSchema = {
  aspectConstructor: ProductAspect,
  renderEditor: ({ aspectValue }) => html`
    <chancen-component-semantic-product-picker-multi
      placeholder-mode="hide"
      @value-picked=${(e: ValueEvent<Maybe<Product[]>>) => {
        aspectValue.values = e.detail.value?.map(v => v._class).filter(v => v) ?? null;
        aspectValue.names = e.detail.value?.map(v => v.name).filter(v => v) ?? null;
      }}
      .value=${aspectValue.values ? aspectValue.values.map(v => ({ _class: v })) : []}
    ></chancen-component-semantic-product-picker-multi>
  `,
  renderPreview: ({ aspectValue }) => (aspectValue.name[0] ? html` ${aspectValue.name[0]} ` : null),
};
